const Dashboard = () => import("../layouts/dashboard.vue");
const DetailsBox = () => import("../pages/boxes/detailsBox.vue");
const ListBox = () => import("../pages/boxes/listBox");

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const boxRoutes = [
  {
    path: "/caixa",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: ListBox,
      },
      {
        path: "criar",
        component: DetailsBox,
      },
      {
        path: ":id/editar",
        component: DetailsBox,
      },
    ],
  },
];
